export default __webpack_public_path__ + "static/media/management-platform.7e622e71.svg";